import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export type CbbButtonVariant = 'green' | 'primary' | 'outline' | 'info' | 'danger' | 'gray';

@Component({
  selector: 'app-cbb-button',
  templateUrl: './cbb-button.component.html',
  styleUrls: ['./cbb-button.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CbbButtonComponent {
  @Input() label = '';
  @Input() color: CbbButtonVariant = 'outline';
  @Input() disabled = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() fullWidth = false;

  @Output() action = new EventEmitter<void>();

  onClick(): void {
    if (!this.disabled) {
      this.action.emit();
    }
  }

  get buttonClass(): string {
    const classes: string[] = ['cbb-btn', `cbb-btn--${this.color}`];
    if (this.fullWidth) {
      classes.push('cbb-btn--full');
    }
    return classes.join(' ');
  }
}
